// extracted by mini-css-extract-plugin
export default {"badge":"styles-module__badge___hAAef","icon":"styles-module__icon___jVRja","content":"styles-module__content___NJl0-","title":"styles-module__title___vPwYu"};